import React from 'react';

const TooltipButton: React.FC<{
  className?: string;
  onClick?: (e?: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  tooltip: string;
  children: React.ReactNode;
  style?: React.CSSProperties;
}> = ({ className, onClick, disabled, tooltip, children, style }) => {
  return (
    <div className="toolbar-btn-wrapper">
      <button
        className={className}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          onClick?.(e);
        }}
        onMouseDown={(e) => {
          e.stopPropagation();
        }}
        disabled={disabled}
        style={style}
      >
        {children}
      </button>
      <div className="custom-tooltip">{tooltip}</div>
    </div>
  );
};

export { TooltipButton };
